module.exports = __webpack_public_path__ + "img/img11.6a42b2e6.png";